import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { KIDefinitionService } from '../../../../services/kidefinition.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-vectorquery-settings',
    templateUrl: './vectorquery.settings.html'
})
export class VectorQuerySettings extends FormulaWorkflowDialogContent {
    Data = new VectorQuerySettingsData();
    KIDefinitions: any[] = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'vectorQueryWFModule';
        reg.Caption = '@@KI: Vektor-Suche';
        reg.GroupID = 'aioperations';
        reg.Index = 103;
        reg.SettingsControl = VectorQuerySettings;
        reg.SettingsTypeHelper = new VectorQuerySettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: KIDefinitionService) {
        super();
    }

    ngOnInit() {
        this.service.GetKIDefinitions('VectorQuery').subscribe(list => {
            this.KIDefinitions = list || [];
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, VectorQuerySettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export class VectorQuerySettingsData {
    KIDefinition: string;
    Model: string = '';
    Collection: string = '';
    Query: string = '';
    TopK: number = 10;
}

export class VectorQuerySettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new VectorQuerySettingsData();
    }
}
